(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const init = () => {
    const sections = document.querySelectorAll('[data-parallax]');
    if (!sections.length) return;
    if (window.innerWidth <= 768) return;

    let ticking = false;

    const update = () => {
      const windowHeight = window.innerHeight;
      const center = windowHeight / 2;

      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > windowHeight + 100) return;

        let target = section.querySelector('[data-parallax-target]');
        if (!target) return;

        if (target.tagName !== 'IMG' && target.tagName !== 'VIDEO') {
          target = target.querySelector('img, video') || target;
        }

        const speed = parseFloat(section.dataset.parallax) || 0.12;
        const sectionCenter = rect.top + rect.height / 2;
        const maxOffset = rect.height * 0.1;
        let offset = (sectionCenter - center) * speed;
        offset = Math.max(-maxOffset, Math.min(maxOffset, offset));

        target.style.setProperty('--parallax-y', offset + 'px');
      });

      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 768) {
        document.querySelectorAll('[data-parallax-target]').forEach(el => {
          var t = (el.tagName !== 'IMG' && el.tagName !== 'VIDEO')
            ? (el.querySelector('img, video') || el) : el;
          t.style.removeProperty('--parallax-y');
        });
      }
    });

    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
